import { createElement, useEffect } from 'react';
import { useNavigate, useLocation, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import routes from "./config";
import { useAuth } from '../context/AuthContext';
import { useSiteMode } from '../context/SiteModeContext';
import MaintenanceScreen from '../components/common/MaintenanceScreen';

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdminUser } = useAuth();
  const { config, maintenanceEnabled } = useSiteMode();

  const isAdminArea = location.pathname.startsWith('/admin');
  const isLoginPage = location.pathname === '/login';
  const isMaintenanceBypassed = isAdminArea || isLoginPage || isAdminUser;
  const redirectTarget = `${location.pathname}${location.search}${location.hash}`;
  const loginHref = `/login?redirect=${encodeURIComponent(redirectTarget)}`;

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  if (maintenanceEnabled && !isMaintenanceBypassed) {
    return createElement(MaintenanceScreen, { config, loginHref });
  }

  return element;
}
